"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var ResultListContainer_1 = __importDefault(require("../containers/ResultListContainer"));
var useStyles = core_1.makeStyles({
    root: {
        width: '100%',
        position: 'relative',
    },
    resultListPart: {
        width: '100%',
        position: 'absolute',
        top: 48,
        left: 0,
        zIndex: 1000000,
    }
});
function AutoComplete(props) {
    var textFieldOtherProps = props.textFieldOtherProps;
    var classes = useStyles();
    var isShowResult = props.isShowResult;
    return (react_1.default.createElement(core_1.Box, { className: classes.root },
        react_1.default.createElement(core_1.TextField, __assign({}, textFieldOtherProps, { fullWidth: true, onChange: props.onChange, value: props.value, label: props.placeholder })),
        react_1.default.createElement(core_1.Box, { className: classes.resultListPart }, isShowResult && (react_1.default.createElement(ResultListContainer_1.default, __assign({}, props))))));
}
;
exports.default = AutoComplete;
